<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>

        <form [formGroup]="editAddContactForm">
          <div class="upperContainer">
            <mat-form-field appearance="outline" class="formField">
              <mat-label for="name">Name</mat-label>
              <input cdkFocusInitial #name matTooltip={{name.value}} matInput placeholder="Name" formControlName="name" />
              @if (editAddContactForm.get('name')?.invalid && (editAddContactForm.get('name')?.dirty || editAddContactForm.get('name')?.touched)) {
                <mat-error>
                  @if (editAddContactForm.get('name')?.errors?.['required']) {
                    Name is required.
                  }
                  @if (editAddContactForm.get('name')?.errors?.['maxlength']) {
                    Name must be no more than 128 characters long.
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="formField">
              <mat-label for="role">Role</mat-label>
              <input #role matTooltip={{role.value}} matInput placeholder="Role" formControlName="role" />
              @if (editAddContactForm.get('role')?.invalid && (editAddContactForm.get('role')?.dirty || editAddContactForm.get('role')?.touched)) {
                <mat-error>
                  @if (editAddContactForm.get('role')?.errors?.['maxlength']) {
                    Role must be no more than 64 characters long.
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="formField">
              <mat-label for="email">Email Address</mat-label>
              <input #email matTooltip={{email.value}} matInput placeholder="Email Address" formControlName="emailAddress" />
              @if (editAddContactForm.get('emailAddress')?.invalid && (editAddContactForm.get('emailAddress')?.dirty || editAddContactForm.get('emailAddress')?.touched)) {
                <mat-error>
                  @if (editAddContactForm.get('emailAddress')?.errors?.['pattern']) {
                    Email is not valid.
                  }
                  @if (editAddContactForm.get('emailAddress')?.errors?.['emailLength']) {
                    Email is too long.
                  }  
                  @if(editAddContactForm.get('emailAddress')?.errors?.['required'] ) {
                    Either phone number or email address is required
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="formField">
              <mat-label for="phone">Phone Number</mat-label>
              <input #phone matTooltip={{phone.value}} matInput placeholder="Phone Number" formControlName="phoneNumber" />
              @if (editAddContactForm.get('phoneNumber')?.invalid && (editAddContactForm.get('phoneNumber')?.dirty || editAddContactForm.get('phoneNumber')?.touched)) {
                <mat-error>
                  @if (editAddContactForm.get('phoneNumber')?.errors?.['maxlength']) {
                    Phone Number is too long.
                  }  
                  @if(editAddContactForm.get('phoneNumber')?.errors?.['required'] ) {
                    Either phone number or email address is required.
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>
      </form>

</mat-dialog-content>
<mat-dialog-actions>
  <div class="actionContainer">
    <button
    mat-button
    (click)="submitContact()"
    id="saveButton"
    [disabled]="!editAddContactForm.valid || this.hasSaveButtonBeenPressed || (isContactSaveDisabled$ | async)"
  >
    Save
  </button>
  <button mat-button mat-dialog-close>Close</button>
</div>
</mat-dialog-actions>